import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useQuery } from 'react-query';

const invalidCardTagIds = ['', 'standardization'];

export default function useFindStandardizationProject(retrieveStandardizationProject) {
  let location = useLocation();
  const [projectId, setProjectId] = useState(null);
  const { data, isLoading, error } = useQuery(['standardizationProjects', { projectId: projectId }], async () => {
    if (!projectId || !retrieveStandardizationProject) return null;
    return (await axios.get(`/standardization/${projectId}`)).data;
  });

  useEffect(() => {
    // url examples: /standardization || /standardization/project/:projectId
    // When we split it by "/" we get ['', standardization] or ['',standardization,project, projectId]
    let pathElements = location.pathname.split('/');
    let _projectId = pathElements[pathElements.length - 1];

    if (!_projectId || invalidCardTagIds.includes(_projectId)) {
      setProjectId(null);
      return;
    }

    setProjectId(_projectId);
  }, [location.pathname]);

  return {
    project: data,
    isLoading: isLoading,
    error,
  };
}
